export const BrandMark = ({ size = "h-9 w-9", testId = "app-logo" }) => (
  <img src="/logo.png" alt="Mango Notes" className={`${size} rounded-xl shadow-sm object-cover`} data-testid={testId} />
);

export const PublicShell = ({ children, testId }) => (
  <div data-testid={testId} className="min-h-screen bg-background text-foreground">
    <header className="max-w-3xl mx-auto px-6 pt-8 flex items-center gap-2">
      <a href="/" className="flex items-center gap-2" data-testid={`${testId}-home-link`}>
        <BrandMark size="h-8 w-8" testId={`${testId}-logo`} />
        <span className="font-display font-bold">Mango Notes</span>
      </a>
      <a href="/" className="ml-auto text-sm text-muted-foreground hover:text-foreground transition-colors" data-testid={`${testId}-back-link`}>← Back to notes</a>
    </header>
    <main className="max-w-3xl mx-auto px-6 py-10 sm:py-16">{children}</main>
  </div>
);
